import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { IReportSection } from './IReportSection.interface';

export interface IPrintingUtilData {
    printPreviewPageClassNameSelector: string;
    printOptionsData: IPrintOptions | undefined;
    isShowAuthoringCompany: boolean;
    authoringCompanyName: string;
    companyName: string;
    companyLogoPdfBase64Getter: () => string | null;
    reportSections: IReportSection[];
}
